import styled from 'styled-components';

import { themeBase } from 'constants/styles/global';

import { media } from 'styles/utils/mediaQueries';

const StyledLogin = styled.div`
    position: relative;
    width: 100%;
    height: fit-content;
    min-height: 100vh;
    display: flex;
    flex-flow: column;
    flex-wrap: nowrap;
    gap: 1.5rem;
    padding-top: 1.5rem;
`;

const StyledLoginSVG = styled.section`
    position: absolute;
    inset: 0;
    display: flex;
    width: 100%;
    justify-content: space-between;
    flex-flow: row nowrap;
    flex: 1;
    z-index: 1;

    .login-svg-ng {
        width: 100%;
        height: 100%;
        background-color: ${themeBase.color.steel50New};

        svg {
            height: 100%;
            width: 100%;
            display: block;
        }
    }
`;

const StyledLoginContainer = styled.section`
    display: flex;
    flex-flow: column nowrap;
    flex-grow: 1;
    align-items: center;
    align-self: center;
    justify-content: center;
    z-index: 10;
    width: 100%;
    max-width: 26.75rem;
    height: 100%;
    padding-inline: 1.875rem;
`;

const StyledLoginContent = styled.div`
    width: 100%;
    height: fit-content;
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    justify-content: center;
    row-gap: 1.25rem;
    padding: 2rem;
    background-color: var(--neutral-white);
    border: 1px solid ${themeBase.color.steel100New};
    box-shadow: 0px 4px 4px 0px #00000014;
    border-radius: ${themeBase.borderRadius.lg};

    ${media.min.tablet`
        padding: 4rem;
    `}

    .login-card-header {
        display: flex;
        align-items: center;
        justify-content: center;

        svg {
            max-width: 13.25rem;
        }
    }

    .login-card-body {
        width: 100%;
        display: flex;
        flex-flow: column nowrap;
        align-items: flex-start;
        justify-content: center;
        row-gap: 1rem;

        h1 {
            font-family: ${themeBase.fontFamilyAccent};
            font-weight: ${themeBase.fontWeight.medium};
            font-size: ${themeBase.fontSize.h3};
            line-height: 100%;
            letter-spacing: 0%;
            color: ${themeBase.color.steel950};
            margin: 0;
        }

        p {
            margin: 0;
            font-size: ${themeBase.fontSize.h5};
            color: ${themeBase.color.steel900New};
        }
    }
`;

/** A field and the buttons under it (change the username, forgot the password). */
const StyledLoginFormFieldGroup = styled.div`
    width: 100%;
    display: flex;
    flex-flow: column nowrap;
    align-items: flex-start;
    justify-content: center;
    row-gap: 0.5rem;

    input[type='password']::-ms-reveal,
    input[type='password']::-ms-clear {
        display: none;
    }
`;

const StyledLoginForm = styled.form`
    width: 100%;
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    row-gap: 1rem;

    button[type='submit'] {
        margin-top: 0.5rem;
    }
`;

// Export at the end to help with Fast Refresh
export { StyledLogin, StyledLoginContainer, StyledLoginContent, StyledLoginForm, StyledLoginFormFieldGroup, StyledLoginSVG };
